export default __webpack_public_path__ + "static/media/hht1_ep6_minisitcom_03.7ca0073d.png";